<template>
  <div class="user-menu">
    <a v-html="userIcon"
       ref="dropButton"
       class="profile-button"
       :class="{'active': menuVisible}"
       href="#"
       @click.prevent="toggleOnClick"
       aria-label="User menu"></a>
    <div ref="dropdown" class="profile-dropdown" v-show="menuVisible">
      <transition name="slide" mode="out-in">
        <div class="dropdown-container" v-if="menuVisible">
          <ul role="menu">
            <li>
              <a :href="getRoute({name: 'userAccount'})">{{ $t('userMenu.myAccount') }}</a>
            </li>
            <li>
              <a href="#" @click.prevent="logoutUser">{{ $t('userMenu.logout') }}</a>
            </li>
          </ul>
          <div ref="arrow" class="profile-dropdown-arrow"></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core'
import auth from '@/mixins/logout'
import { customRouter } from '@/customRouter'
import { customEvent } from '@/services/customEventBus'
import { user } from '@/components/common/icons/svgIcons'

export default {
  name: 'user-menu',
  data () {
    return {
      menuVisible: false,
      popperjs: null
    }
  },
  mixins: [auth],
  computed: {
    userIcon () {
      return user
    }
  },
  methods: {
    createPopup () {
      const drop = this.$refs.dropButton
      const dropdown = this.$refs.dropdown
      const arrow = this.$refs.arrow
      this.$nextTick(() => {
        this.popperjs = createPopper(drop, dropdown, {
          placement: 'bottom-end',
          strategy: 'fixed',
          modifiers: [
            {
              name: 'flip',
              options: {
                fallbackPlacements: ['bottom-end'],
                padding: 5,
                rootBoundary: 'viewport',
                allowedAutoPlacements: ['bottom-end', 'bottom-start']
              }
            },
            {
              name: 'offset',
              options: {
                offset: [15, 15]
              }
            },
            {
              name: 'preventOverflow'
            },
            {
              name: 'arrow',
              options: {
                element: arrow,
                padding: 5
              }
            }
          ]
        })
      })
    },
    closePopup () {
      this.menuVisible = false
      if (this.popperjs) {
        this.popperjs.destroy()
      }
      this.popperjs = null
    },
    toggleOnClick () {
      this.menuVisible = !this.menuVisible
    },
    handleDocumentClick (e) {
      if (e.target !== this.$refs.dropButton) this.closePopup()
    },
    getRoute (route) {
      return customRouter.getRouteByName(route)
    }
  },
  watch: {
    menuVisible (newVal) {
      if (newVal) {
        this.createPopup()
        customEvent.$emit('notification:toggle', false)
      } else this.closePopup()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.createPopup()
      document.addEventListener('click', this.handleDocumentClick)
    })
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleDocumentClick)
  }
}
</script>

<style scoped lang="scss" src="./styles/dropdown.scss"></style>
